import { useQuery } from '@tanstack/react-query';
import { AirtableService } from '../../shared/airtable';

const Airtable = new AirtableService(
  process.env.REACT_APP_AIRTABLE_API_KEY || '',
);

const useBaseTableSingleRecord = (
  baseId: string,
  tableId: string,
  recordId: string,
  enabled: boolean,
) => {
  const { data, isLoading, error, isError } = useQuery({
    queryKey: ['base-tables', { baseId, tableId, recordId }],
    queryFn: () => Airtable.getTableRecord(baseId, tableId, recordId),
    staleTime: 1000 * 10,
    retry: false,
    select: (data) => data?.fields,
    enabled,
  });

  return {
    isLoading,
    isError,
    error,
    data,
    fetcherFn: Airtable.getTableRecord,
  };
};

export default useBaseTableSingleRecord;
